import React from 'react'
import { Link } from 'react-router'
import { Button } from '@sketchpixy/rubix'
import * as MabnaButton from '../common/Button/Button'

const Heading = () => (
  <div className="text-center bg-darkblue fg-white" style={{ flex: 1, marginBottom: 10 }}>
    <h4 style={{ margin: 0, padding: 10 }}>عضویت در سامانه</h4>
  </div>
)

const Title = () => (
  <div style={{ textAlign: 'center' }}>
    <h4>لطفا جهت عضویت یکی از موارد زیر را انتخاب کنید</h4>
  </div>
)

const ActionButtons = () => (
  <div>
    <Link to="/signup/student">
      <MabnaButton.Primary outline buttonSize='large' className="auth-buttons" style={{display: 'block'}}>
        دانش آموز هستم
      </MabnaButton.Primary>
    </Link>

    <Link to="/signup/school">
      <MabnaButton.Primary outline buttonSize='large' className="auth-buttons" style={{display: 'block'}}>
        مسئول مرکز آموزشی هستم
      </MabnaButton.Primary>
    </Link>
  </div>
)

const BackButton = () => (
  <div style={{ textAlign: 'center' }}>
    <Link to="/">بازگشت</Link>
  </div>
)

const SignupChooseUserType = () => (
  <div className="choose-usertype">
    <Heading />
    <Title />
    <ActionButtons />
    <BackButton />
  </div>
)

export default SignupChooseUserType



// WEBPACK FOOTER //
// ./src/components/authentication/SignupChooseUserType.js